/** Parses a typed number, accepting a decimal comma. Empty input is null. */
export const toNumber = (value: string) => {
  const normalized = value.trim().replace(',', '.');

  return normalized === '' ? null : Number(normalized);
};

export const isCoordinate = (value: string, limit: number) => {
  const number = toNumber(value);

  return number != null && Number.isFinite(number) && Math.abs(number) <= limit;
};

/** WGS 84 point from typed values, or null when either value is invalid. */
export const toPoint = (latitude: string, longitude: string) =>
  isCoordinate(latitude, 90) && isCoordinate(longitude, 180)
    ? {
        latitude: Number(toNumber(latitude)),
        longitude: Number(toNumber(longitude)),
      }
    : null;
